import { useRef } from "react";

import i18next from "i18next";

import { ChooseButton, Error, FileBlock, FileGroup, FileName, Hint, Label } from "./style";

// Выбор одного файла: кнопка + имя выбранного файла, подсказка о форматах и ошибка — в стиле InputComponent.
const FileInput = ({
  value = null,
  onChange = () => null,
  onBlur = () => null,
  accept,
  label = null,
  required = false,
  hint = null,
  touched = false,
  error = null,
  disabled,
}) => {
  const { t } = i18next;
  const inputRef = useRef(null);

  const handleChange = e => {
    const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
    onChange(file);
    onBlur();
    // сброс, чтобы повторный выбор того же файла снова вызывал onChange
    e.target.value = "";
  };

  return (
    <FileGroup>
      <FileBlock isError={touched && error}>
        <input ref={inputRef} type="file" accept={accept} onChange={handleChange} disabled={disabled} />
        <div style={{ flex: 1, minWidth: 0 }}>
          {label && (
            <Label>
              {label} {required && <span>*</span>}
            </Label>
          )}
          <FileName isEmpty={!value}>{value ? value.name : t("file_not_chosen")}</FileName>
        </div>
        <ChooseButton>{t("choose_file")}</ChooseButton>
      </FileBlock>
      {hint && !(touched && error) && <Hint>{hint}</Hint>}
      {touched && error && <Error>{error}</Error>}
    </FileGroup>
  );
};

export default FileInput;
